
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trial",
      function () {
        return require("private-next-pages/trial/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trial"])
      });
    }
  